import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '~/eds/src/components/Button/Button';
import { FormattedMessage, useIntl } from 'react-intl';
import Box from '~/ui/components/Box/Box';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Text from '~/ui/components/Text/Text';
import { copyToClipboard } from '~/utils/helper.utils';

const TicketInboundEmail = ({ ticketEmail }) => {
  const intl = useIntl();
  return (
    <Box mt={4}>
      <Text color="gray-900" variant="s-dense">
        <FormattedMessage
          id="TicketInboundEmail.description"
          defaultMessage="Send a file directly to this ticket to have it automatically added as a new version."
          description="Instructional text for sending a file to the ticket email."
        />
      </Text>
      <FlexLayout
        alignItems="center"
        justifyContent="space-between"
        px={4}
        py={1}
        space={4}
        bg="gray-100"
        sx={{
          border: 'border',
          borderColor: 'gray-500',
          borderRadius: 'm',
          height: 'input-height',
        }}
        mt={2}
      >
        <Text
          color="gray-700"
          variant="xs-dense"
          shouldTruncate={true}
          toolTipPlacement="bottom"
        >
          {ticketEmail}
        </Text>
        <Button
          text={intl.formatMessage({
            id: 'TicketInboundEmail.copyLink',
            defaultMessage: 'Copy link',
            description: 'Button text to copy the ticket email link.',
          })}
          variant="action"
          onClick={() =>
            copyToClipboard(
              ticketEmail,
              intl.formatMessage({
                id: 'TicketInboundEmail.copySuccess',
                defaultMessage: 'Ticket email copied to clipboard.',
                description:
                  'Success message when ticket email is copied to clipboard.',
              }),
            )
          }
        />
      </FlexLayout>
    </Box>
  );
};

TicketInboundEmail.propTypes = {
  ticketEmail: PropTypes.string.isRequired,
};

export default TicketInboundEmail;
